/* ==========================================================================
  header 顯示頁面分類
========================================================================== */

"use strict";
$(document).click(function (e) {
  const target = $(e.target);

  // 如果點擊的是 .button-toggle，則切換開關狀態
  if (target.closest(".button-toggle").length) {
    e.preventDefault();
    $(".button-toggle").toggleClass("active");
    $(".dropdown").toggleClass("opening");
  } 
  // 如果點擊的是 .nav-wrap，關閉所有開關狀態
  else if (target.closest(".nav-wrap").length) {
    $(".button-toggle").removeClass("active");
    $(".dropdown").removeClass("opening");
  } 
  // 如果點擊其他地方，關閉菜單
  else {
    $(".button-toggle").removeClass("active");
    $(".dropdown").removeClass("opening");
  }
});

/* ==========================================================================
  gsap js
========================================================================== */
document.addEventListener("DOMContentLoaded", () => {
  const boxes = Array.from(document.querySelectorAll(".frame"));

  // 設置每個 box 的背景圖
  boxes.forEach(box => {
    const bgImage = box.getAttribute("data-bg");
    if (bgImage) {
      box.style.backgroundImage = ` url(${bgImage})`;
    }
  });
  const specificBox = boxes[5];
  const otherBoxes = boxes.filter(box => box !== specificBox);

  // 隨機排列其他方框
  function shuffleBoxes() {
    return otherBoxes.sort(() => Math.random() - 0.5);
  }

  const tl = gsap.timeline({ defaults: { duration: 1, ease: "power2.out" } });

  shuffleBoxes().forEach((box, index) => {
    tl.fromTo(
      box,
      { opacity: 0, scale: 0.5, y: 50 },
      { opacity: 1, scale: 1, y: 0 },
      index * 0.3
    );
  });

  tl.fromTo(
    specificBox,
    { opacity: 0, scale: 0.5, y: 50 },
    {
      opacity: 1,
      scale: 1,
      y: 0
    }
  );
});

/* ==========================================================================
  lightbox js
========================================================================== */
document.addEventListener("DOMContentLoaded", function () {
  // 直接在 JavaScript 中定義醫生資料
  const doctors = [
      { id: 1,
        department:'心臟內科',
        name: '宋思賢',
        title:'台北榮總心臟內科主治醫師',
        info: '心臟瓣膜手術權威，技術與溫度兼具',
        recommend:'台灣介入性心臟血管醫學會',
        reasons: '積極參與國際會議與短期出國進修，學習新技術與新器械。專精經導管心臟瓣膜置換與修補，技術卓越。跨科合作成立肺高壓及心臟衰竭照護團隊，展現仁心仁術。',
        image: "./images/lightbox/doctor1.jpg",
        mobileImage:"./images/lightbox/doctor1-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91036", // 新增的 link 欄位
        registration: "https://www.vghtpe.gov.tw/Docpersnr.action?tno=DOC1255L"
      },
      { id: 2,
        department:'胃腸肝膽科',
        name: '蘇東弘',
        title:'台大醫院內科部胃腸肝膽科主治醫師、臨床教授',
        info: '檢查總親自上陣，病人一句謝謝是最大成就',
        recommend:'台灣消化系醫學會',
        reasons: '多次受邀於亞太及各國肝病醫學會擔任講者，積極指導醫學生及住院醫師進行臨床研究，並任台大肝炎研究中心主治醫師，為胃腸肝膽科醫師的典範。',
        image: "./images/lightbox/doctor2.jpg",
        mobileImage:"./images/lightbox/doctor2-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91033",
        registration: "https://www.ntuh.gov.tw/Med/Vcard.action?q_type=A03&q_itemCode=432"
      },
      { 
        id: 3,
        department:'感染科',
        name: '黃崧溪',
        title:'新竹台大分院感染科主治醫師',
        info: '從導遊到非洲醫療救援，踏遍世界守護生命',
        recommend:'台灣感染症醫學會',
        reasons: '曾經參與無國界醫生組織，在戰亂的南蘇丹和史瓦帝尼王國出勤務，目前也在新竹台大分院負責國際醫療業務，是年輕感染科醫師的典範。',
        image: "./images/lightbox/doctor3.jpg",
        mobileImage:"./images/lightbox/doctor3-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91015",
        registration: "https://www.hch.gov.tw/?aid=51&pid=9&page_name=detail&iid=64"
      },
      { id: 4,
        department:'風濕免疫過敏科',
        name: '盧俊吉',
        title:'三軍總醫院風濕免疫過敏科主治醫師',
        info: '從陪母求診到成名醫，跨科治不孕護「免疫媽媽」',
        recommend:'中華民國風濕病醫學會',
        reasons: '專精風濕免疫科，跨科參與不孕症治療。執行三總器官移植免疫評估，也曾支援醫療資源不足區，堅持人性關懷，是年輕風濕免疫科醫師的典範。',
        image: "./images/lightbox/doctor4.jpg",
        mobileImage:"./images/lightbox/doctor4-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91142",
        registration: "https://wwwv.tsgh.ndmctsgh.edu.tw/docdet/191/10032/24980/282"
      },
      { 
        id: 5,
        department:'腎臟科',
        name: '楊智宇',
        title:'台北榮總內科部腎臟科主治醫師',
        info: '好醫生不需要最聰明，3個特質最重要',
        recommend:'台灣腎臟醫學會',
        reasons: '積極推廣腹膜透析居家醫療，與國際學會簽訂合作備忘錄。發明「治療纖維化透析液」並取得專利，開發「AI即時預測腎病預後決策輔助系統」獲國家新創獎與美國專利。',
        image: "./images/lightbox/doctor5.jpg",
        mobileImage:"./images/lightbox/doctor5-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90969",
        registration: "https://www.vghtpe.gov.tw/Docpersnr.action?tno=DOC1201C"
      },
      {
        id: 6,
        department:'感染科',
        name: '鄭琬豑',
        title:'台大醫院內科部感染科主治醫師',
        info: '跳脫框架，不放棄為病人找答案',
        recommend:'台灣內科醫學會',
        reasons: '經常收到感謝函，顯示醫病間的深厚信任。積極參與國際醫療合作，論文發表於《新英格蘭期刊》。致力推動精準醫學，提供個人化治療策略，積極指導後進，深獲愛戴。',
        image: "./images/lightbox/doctor6.jpg",
        mobileImage:"./images/lightbox/doctor6-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90968",
        registration: "https://www.ntuh.gov.tw/Med/Vcard.action?q_type=A06&q_itemCode=519"
      },
      {
        id: 7,
        department:'神經內科',
        name: '鍾芷萍',
        title:'台北榮總神經醫學中心腦血管科主任',
        info: '腦健康的溫柔先驅，從細節發現腦疾新轉機',
        recommend:'台灣神經學學會',
        reasons: '擅從細微變化發現疾病背後的未知機轉，開創腦病診療新方向。帶領團隊挽救腦中風病患的生命與腦功能，投入高齡醫學研究，守護腦血管健康，為腦中風治療中堅力量。',
        image: "./images/lightbox/doctor7.jpg",
        mobileImage:"./images/lightbox/doctor7-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91143",
        registration: "https://www.vghtpe.gov.tw/Teacher.action?tid=699"
      },
      {
        id: 8,
        department:'內分泌暨新陳代謝科',
        name: '周振凱',
        title:'高雄長庚醫院內分泌暨新陳代謝科主任、副教授級主治醫師',
        info: '不只耐心更耐煩，以助人初心行醫者大路',
        recommend:'中華民國內分泌學會',
        reasons: '術德兼備，曾赴馬祖、澎湖及屏東偏鄉義診，獲優良服務人員獎。屢有突破性研究，獲國家生技醫療品質獎銀獎，並受邀在國際重要會議演講。推動跨域合作，提攜後進。',
        image: "./images/lightbox/doctor8.jpg",
        mobileImage:"./images/lightbox/doctor8-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91001",
        registration: "https://www.cgmh.org.tw/tw/Services/DoctorInfo/6150"
      },
      {
        id: 9,
        department:'胸腔內科',
        name: '潘聖衛',
        title:'台北榮總胸腔部呼吸感染免疫科主治醫師、陽明交大醫學院兼任副教授',
        info: '「視病猶親」是基本，讓病人聽懂最重要',
        recommend:'台灣胸腔暨重症加護醫學會',
        reasons: '長年照護慢性呼吸道感染症患者。多次參與美國胸腔醫學會國際年會，針對肺結核及非結核分枝桿菌肺病議題發表報告，3度獲得美國胸腔醫學會國際年會優秀論文獎。',
        image: "./images/lightbox/doctor9.jpg",
        mobileImage:"./images/lightbox/doctor9-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91034",
        registration: "https://www.vghtpe.gov.tw/Docpersnr.action?tno=DOC5352G"
      },
      {
        id: 10,
        department:'心臟外科',
        name: '楊翔宇',
        title:'三軍總醫院心臟血管外科主治醫師、實驗外科中心科主任',
        info: '就是想動手救人，把患者從鬼門關前拉回來',
        recommend:'台灣胸腔及心臟血管外科學會',
        reasons: '專攻心律不整及心臟衰竭研究，24小時待命搶救病患。曾在亞太體外維生系統大會和國際急性機械循環輔助研討會擔任講者，2025年代表外科醫學會於學術外科年會發表演講。',
        image: "./images/lightbox/doctor10.jpg",
        mobileImage:"./images/lightbox/doctor10-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90946",
        registration: "https://wwwv.tsgh.ndmctsgh.edu.tw/docdet/191/10011/24959/680"
      },
      { 
        id: 11,
        department:'耳鼻喉科',
        name: '王棨德',
        title:'亞東醫院耳鼻喉部主治醫師',
        info: '要成為10％的關鍵少數，突破嗓音治療瓶頸',
        recommend:'台灣耳鼻喉頭頸外科醫學會',
        reasons: '術德兼備，致力發展咽喉手術，多次赴美日進修，引進聲帶注射、綠光雷射等新技術。近來將AI應用於耳鼻喉科領域，發表病理嗓音偵測與即時行動用聲測量研究。',
        image: "./images/lightbox/doctor11.jpg",
        mobileImage:"./images/lightbox/doctor11-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91037",
        registration: "https://www.femh.org.tw/section/sectionDetail2.aspx?CID=0250&&DoctorID=87910"
      },
      { 
        id: 12,
        department:'大腸直腸外科',
        name: '賴正大',
        title:'馬偕醫院大腸直腸外科資深主治醫師',
        info: '從叛逆少年到大腸癌權威，敢說真話才是真良醫',
        recommend:'中華民國大腸直腸外科醫學會',
        reasons: '積極出席公私部門會議，宣揚大腸直腸疾病預防知識，提升自身能力並赴美進修；提攜後進，臨床手術不吝傳授所學。受邀擔任機械手臂課程講師，參與課程教學規劃。',
        image: "./images/lightbox/doctor12.jpg",
        mobileImage:"./images/lightbox/doctor12-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91144",
        registration: "https://post.mmh.org.tw/taitam/col_su/team.html#t108"
      },
      {
        id: 13,
        department:'胸腔外科',
        name: '林孟暐',
        title:'台大醫院外科部主治醫師、台灣大學醫學院臨床教授',
        info: '外科界的「奇異博士」，哈佛首位亞洲胸外訪問教授',
        recommend:'台灣胸腔外科醫學會',
        reasons: '2020年獲台大外科部主治醫師優異獎，2021年獲台灣胸腔外科學會最佳手術影片獎首獎；2024年獲哈佛大學聘為訪問外科教授，是首位獲此殊榮的亞洲胸腔外科醫師。',
        image: "./images/lightbox/doctor13.jpg",
        mobileImage:"./images/lightbox/doctor13-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91000",
        registration: "https://www.ntuh.gov.tw/surg/Vcard.action?q_type=6&q_itemCode=491"
      },
      { 
        id: 14,
        department:'神經外科',
        name: '謝政達',
        title:'國泰綜合醫院神經外科主任',
        info: '老鷹眼、獅子心、靈巧手，勇於挑戰急重難病症',
        recommend:'台灣神經外科醫學會',
        reasons: '將患者福祉放首位，急性搶救階段展現高超手術技巧，術後提供全方位關懷。鑽研腦損傷、脊髓疾病及腫瘤診治，研究成果多次發表於國際SCI期刊，對專業貢獻卓著。',
        image: "./images/lightbox/doctor14.jpg",
        mobileImage:"./images/lightbox/doctor14-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91002",
        registration: "https://www.cgh.org.tw/ec99/rwd1320/product_doct.asp?prodid=13598&category_id=27"
      },
      {
        id: 15,
        department:'泌尿外科',
        name: '羅浩倫',
        title:'高雄長庚醫院泌尿科主任、高雄長庚醫院泌尿科醫師',
        info: '從刀尖到心間皆用心，超凡的達文西手術專家',
        recommend:'台灣泌尿科醫學會',
        reasons: '專精泌尿科達文西手術，擔任高雄長庚醫院泌尿腫瘤團隊召集人。與團隊合作改善患者手術預後，仔細向患者衛教。積極提攜後進，帶領年輕醫師發表國際論文。',
        image: "./images/lightbox/doctor15.jpg",
        mobileImage:"./images/lightbox/doctor15-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90976",
        registration: "https://www.cgmh.org.tw/tw/Services/DoctorInfo/6470"
      },
      { 
        id: 16,
        department:'心臟外科',
        name: '張睿智',
        title:'花蓮慈濟醫院外科部主任兼心臟血管外科主任、慈濟大學醫學系外科專任教授兼學科主任',
        info: '藝術般精湛的外科專業，對生命全力以赴',
        recommend:'台灣外科醫學會',
        reasons: '推動資源匱乏地區醫療品質提升，帶領團隊成功執行高難度心臟手術。積極推廣模擬手術訓練，提升年輕醫師手術技巧，促成跨醫學會合作，參與國際會議分享專業經驗。',
        image: "./images/lightbox/doctor16.jpg",
        mobileImage:"./images/lightbox/doctor16-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90970",
        registration: "https://hlm.tzuchi.com.tw/cvs/index.php/15-team-introduction/1106-d1-2011-07-29-09-07-21"
      },
      { 
        id: 17,
        department:'整形外科',
        name: '蔡嘉軒',
        title:'基隆長庚醫院整形外科主任、亞洲暨太平洋疤痕治療協會理事',
        info: '挑戰冷門蟹足腫治療，「疤痕剋星」追求美與極致',
        recommend:'台灣整形外科醫學會',
        reasons: '設身處地為病人著想。2016年支援台東馬偕醫院。2017年赴日進修蟹足腫最新治療技術，回台成立跨領域團隊，吸引海外病人。基隆長庚整形外科在他領導下日漸茁壯。',
        image: "./images/lightbox/doctor17.jpg",
        mobileImage:"./images/lightbox/doctor17-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91016",
        registration: "https://www.cgmh.org.tw/tw/Services/DoctorInfo/7407"
      },
      {
        id: 18,
        department:'兒科',
        name: '陳慧如',
        title:'馬偕醫院兒童發展暨早期療育評估中心主任',
        info: '力推兒童發展篩檢，盼早點找出「慢飛天使」',
        recommend:'台灣兒科醫學會',
        reasons: '以分級分流概念解決早療塞車現況，推動兒童發展篩檢，開發新量表提升篩檢率，幫助更多發展遲緩的孩子及早接受治療。推廣親子共讀，成立「小星星閱讀家族」。',
        image: "./images/lightbox/doctor18.jpg",
        mobileImage:"./images/lightbox/doctor18-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90990",
        registration: "https://www.mmh.org.tw/child/doctor_view.php?depid=7&did=20"
       },
      {
        id: 19,
        department:'婦產科',
        name: '黃楚珺',
        title:'台大醫院雲林分院婦產部主任、台大醫院婦產部生殖內分泌科主治醫師',
        info: '熱愛迎接新生命，陪不孕患者一試再試',
        recommend:'台灣婦產科醫學會',
        reasons: '專精不孕症及多囊性卵巢症候群治療，曾多次受邀於美國及歐洲生殖醫學會發表論文摘要。研究屢獲台灣生殖醫學會及不孕症基金會等單位的優秀論文獎。',
        image: "./images/lightbox/doctor19.jpg",
        mobileImage:"./images/lightbox/doctor19-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90947",
        registration: "https://www.ntuh.gov.tw/obgy/Vcard.action?q_type=-1&q_itemCode=602"
      },
      {
        id: 20,
        department:'眼科',
        name: '朱筱桑',
        title:'台大醫院眼科部主治醫師、台大醫學院臨床助理教授',
        info: '把溫柔都給了病人，最想幫助患者重見陽光',
        recommend:'中華民國眼科醫學會',
        reasons: '待病人一視同仁，展現高度專業素養。多年支援偏鄉醫療，積極參與國際醫療合作。協助台灣國家眼庫與國際接軌，並組跨國團隊進行角膜捐贈與眼庫管理相關的研究。',
        image: "./images/lightbox/doctor20.jpg",
        mobileImage:"./images/lightbox/doctor20-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91035",
        registration: "https://www.ntuh.gov.tw/OPH/Vcard.action?q_type=A03&q_itemCode=485"
      },
      {
        id: 21,
        department:'皮膚科',
        name: '楊朝鈞',
        title:'成大醫院皮膚部主任、成大醫學系皮膚學科教授',
        info: '醫病先醫心，南部拯救落髮第1把交椅',
        recommend:'台灣皮膚科醫學會',
        reasons: '是國內治療落髮權威，長期支援偏鄉醫療，同時也主持國內第一份圓禿治療指引。同時為成大醫學系副系主任，致力於醫學教育及醫學生、教師國際交流。',
        image: "./images/lightbox/doctor21.jpg",
        mobileImage:"./images/lightbox/doctor21-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91145",
        registration: "https://derm.hosp.ncku.edu.tw/p/404-1091-257482-1.php"
      },
      {
        id: 22,
        department:'家醫科',
        name: '林季緯',
        title:'義大醫院醫學教育部部長',
        info: '培養全人醫師的教育家，發揮家醫科影響力',
        recommend:'台灣家庭醫學醫學會',
        reasons: '建構發展義大醫院跨科別社區支援任務，並擔任全球無菸健康照護服務網絡理事，前往海外友邦與資源不足區域，參與各項援外與國際醫療與教育合作計畫。',
        image: "./images/lightbox/doctor22.jpg",
        mobileImage:"./images/lightbox/doctor22-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90999",
        registration: "https://webreg.edah.org.tw/Register/ChooseDoctorTime/1605"
      },
      {
        id: 23,
        department:'家醫科',
        name: '彭仁奎',
        title:'台大醫院家庭醫學部主治醫師、緩和醫療科主任',
        info: '不把死亡當敵人，陪病人放下',
        recommend:'台灣老年學暨老年醫學會',
        reasons: '面對病患敘述病情時親切有耐心，解說病情與照護的態度專業又細心。',
        image: "./images/lightbox/doctor23.jpg",
        mobileImage:"./images/lightbox/doctor23-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91041",
        registration: "https://www.ntuh.gov.tw/FM/Vcard.action?q_type=-1&q_itemCode=659"
      },
      {
        id: 24,
        department:'血液腫瘤科',
        name: '黃泰中',
        title:'台大醫院內科部血液腫瘤科主治醫師，中華民國血液病學會秘書長',
        info: '從病人角度找解方，淋巴癌領域「醫生中的醫生」',
        recommend:'中華民國血液病學會',
        reasons: '淋巴癌治療翹楚，首創次世代定序診斷淋巴癌，參與多國學術會議與跨國臨床試驗，主持台灣首例成人淋巴癌CAR-T治療。曾獲台大醫院主治醫師優異獎、教學付出獎。',
        image: "./images/lightbox/doctor24.jpg",
        mobileImage:"./images/lightbox/doctor24-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91018",
        registration: "https://www.ntuh.gov.tw/Med/Vcard.action?q_type=A09&q_itemCode=1306"
      },
      {
        id: 25,
        department:'急診科',
        name: '林晏任',
        title:'彰基體系急診暨重症醫學部主任、醫務秘書',
        info: '從40分鐘縮短到30秒，研發晶片讓救命速度大進化',
        recommend:'台灣急診醫學會',
        reasons: '關注偏鄉醫療，導入高科技工具，成功研發出應用於救護車上的微型心肌酵素晶片。帶領年輕醫師團隊在國際舞台上發光，獲3次世界急診醫學會最佳年輕學者獎。',
        image: "./images/lightbox/doctor25.jpg",
        mobileImage:"./images/lightbox/doctor25-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90998",
        registration: "https://www1.cch.org.tw/about/about_7.aspx?id=0117214&sno=&dr_no=117214&pid=#MainTop"
      },
      {
        id: 26,
        department:'復健科',
        name: '張凱閔',
        title:'台大醫院北護分院復健科主治醫師、台大醫學院臨床教授',
        info: '名列全球前2％頂尖科學家，最會做研究的超音波權威',
        recommend:'台灣復健醫學會',
        reasons: '投入肌肉骨骼超音波，與國外學術單位和醫院合作大體研究，將研究結果應用於臨床，成為世界治療參考。至2024年9月發表364篇論文，連續3年躋身全球前2%頂尖科學家。',
        image: "./images/lightbox/doctor26.jpg",
        mobileImage:"./images/lightbox/doctor26-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91146",
        registration: "https://www.bh.ntuh.gov.tw/?aid=51&pid=12&page_name=detail&iid=41"
      },
      {
        id: 27,
        department:'牙科',
        name: '蔡欣原',
        title:'艾來牙醫診所醫師',
        info: '共感患者的痛，激勵小病人投身牙醫',
        recommend:'中華民國牙醫師公會全聯會',
        reasons: '平等對待每位病患，凡事充分溝通，隨時與病人及家屬說明病情進展及處置計畫。並積極配合政府及公會推動政策、參與公共衛生事項。',
        image: "./images/lightbox/doctor27.jpg",
        mobileImage:"./images/lightbox/doctor27-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90997",
        registration: "https://www.ilifedental.com.tw/team-single-8.html"
      },
      {
        id: 28,
        department:'精神科',
        name: '李正達',
        title:'台北榮總精神部社區復健精神科主任、精神部主治醫師',
        info: '翻轉憂鬱症命運，從零到有，他讓科幻成真',
        recommend:'台灣精神科醫學會',
        reasons: '台灣rTMS的先驅，專注憂鬱症科學研究，樂於提攜後進。',
        image: "./images/lightbox/doctor28.jpg",
        mobileImage:"./images/lightbox/doctor28-m.jpg",
        link: "https://www.commonhealth.com.tw/article/90994",
        registration: "https://www.vghtpe.gov.tw/Docpersnr.action?tno=DOC3320L"
      },
      {
        id: 29,
        department:'中醫',
        name: '蔡明諺',
        title:'高雄長庚醫院中醫部主任、長庚大學中醫系部定副教授',
        info: '中西醫合療先行者，用心記住每一位病人',
        recommend:'中華民國中醫師公會全聯會',
        reasons: '屢有突破性研究成果及技術發表。仁心仁術，關注健康不平等，帶領中醫師前往醫療不足區服務長達10年，積極參與國際醫療合作，協助尼泊爾建立中醫團隊。',
        image: "./images/lightbox/doctor29.jpg",
        mobileImage:"./images/lightbox/doctor29-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91147",
        registration: "https://www.cgmh.org.tw/tw/Services/DoctorInfo/6425"
      },
      {
        id: 30,
        department:'麻醉科',
        name: '王柏凱',
        title:'花蓮慈濟醫院麻醉部副主任暨疼痛科主任、品管中心術後加速康復組負責人',
        info: '東台灣最頂尖疼痛治療專家，超音波導引神技精準減痛',
        recommend:'台灣麻醉醫學會',
        reasons: '擅長各種疼痛控制技術，成立花東首間疼痛治療中心，開創台灣超音波導引下區域麻醉止痛大體模擬訓練，強調跨科合作、加速患者康復。長年支援偏鄉醫療、守護居民。',
        image: "./images/lightbox/doctor30.jpg",
        mobileImage:"./images/lightbox/doctor30-m.jpg",
        link: "https://www.commonhealth.com.tw/article/91017",
        registration: "https://hlm.tzuchi.com.tw/pain/index.php/15-team-introduction/135-pk"
      }
  ];

  // Lightbox elements
  const lightbox = document.getElementById("lightbox");
  const doctorDepartment = document.getElementById("department");
  const doctorName = document.getElementById("doctor-name");
  const doctorTitle = document.getElementById("doctor-title");
  const doctorInfo = document.getElementById("doctor-info");
  const doctorRecommend = document.getElementById("doctor-recommend");
  const doctorReasons = document.getElementById("doctor-reasons");
  const doctorLink = document.getElementById("doctor-link");
  const registrationLink = document.getElementById("registration-link");
  const doctorImage = document.getElementById("doctor-image"); // 這是 div
  const closeBtn = document.getElementById("close-btn");

  // Event listener for all doctor links in all groups
  document.querySelectorAll(".doctor-btn").forEach(link => {
      link.addEventListener("click", function (event) {
          event.preventDefault(); // 阻止 <a> 元素的默認跳轉行為
          const doctorId = parseInt(this.getAttribute("data-id"));
          const doctor = doctors.find(d => d.id === doctorId);

          console.log(doctor);
          console.log(doctor.page);
          console.log(registrationLink);

          if (doctor) {
              doctorDepartment.textContent = doctor.department;
              doctorName.textContent = doctor.name;
              doctorTitle.textContent = doctor.title;
              doctorInfo.textContent = doctor.info;
              doctorRecommend.textContent = doctor.recommend;
              doctorReasons.textContent = doctor.reasons;
              doctorLink.href = doctor.link;
              doctorLink.setAttribute('content_type', doctor.department); //設定屬性
              doctorLink.setAttribute('content_title', doctor.name); //設定屬性
              registrationLink.href = doctor.registration; 
              registrationLink.setAttribute('content_type', doctor.department); //設定屬性
              registrationLink.setAttribute('content_title', doctor.name); //設定屬性
              //doctorImage.style.backgroundImage = `url(${doctor.image})`; // 設置背景圖像
              // **檢查裝置寬度並選擇對應的圖片**
              const imageUrl = window.innerWidth <= 425 ? doctor.mobileImage : doctor.image;
              doctorImage.style.backgroundImage = `url(${imageUrl})`;

              lightbox.classList.add("visible");
          }
      });
  });

  // Close button functionality
  closeBtn.addEventListener("click", function () {
      lightbox.classList.remove("visible");
  });

  // Close lightbox when clicking outside content
  lightbox.addEventListener("click", function (e) {
      if (e.target === lightbox) {
          lightbox.classList.remove("visible");
      }
  });
});



